import PropTypes from 'prop-types'
import React, { useState, useCallback } from 'react'
import { Modal, Form } from 'antd'
import { NotificationEmailForm } from './form'

export const NotificationEmailModal = ({ onCreate, onCancel, visible }) => {
  const [form] = Form.useForm()
  return (
    <Modal
      visible={visible}
      title="Provide an email and we'll send you a notification when the final karaoke song is ready to sing!"
      okText="Submit"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields()
            onCreate(values)
          })
          .catch((info) => {
            console.log('Validate Failed:', info)
          })
      }}
    >
      <NotificationEmailForm form={form} />
    </Modal>
  )
}

export const NotificationEmailButton = ({
  button: Button,
  onSuccess,
  ...props
}) => {
  const [visible, setVisible] = useState(false)
  const onCreate = useCallback(
    (values) => {
      console.log('Received values of form: ', values)
      setVisible(false)
      onSuccess(values)
    },
    [onSuccess]
  )
  const onCancel = useCallback((values) => {
    setVisible(false)
  }, [])
  const open = useCallback(() => {
    setVisible(true)
  }, [])

  return (
    <>
      <Button {...props} onClick={open} />
      <NotificationEmailModal
        visible={visible}
        onCancel={onCancel}
        onCreate={onCreate}
      />
    </>
  )
}

NotificationEmailButton.defaultProps = {
  button: () => <button />,
  onSuccess: () => {},
}

NotificationEmailButton.propTypes = {
  button: PropTypes.elementType,
  onSuccess: PropTypes.func,
}
